export const validation = {
  email: 'Please Enter email',
  password: 'Please Enter password',
  notesRequired:"Note is required"
};
